import React from 'react';

function PrivateEvents() {
  return (

<div className="container mx-auto p-8">
      <div className="bg-white rounded-lg mt-8 shadow-lg p-6 border border-gray-400">
        <h1 className="text-3xl font-bold  mb-6">About Private Events</h1>
        
        <div className="space-y-4 text-left">
         
        <div className="prose max-w-none">
        <p className="mb-4">
          ATL Tech Events lists placeholder events for private events we are aware of so that your plans can include these events. We do not provide details by default as the organizer may prefer to keep it private. If you are the host of a private event, and would like to have the details listed, we have several options.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Private Event Listings</h2>
        <ul className="list-disc pl-6 mb-6">
          <li>$30 to list a single event (event and organization name, description, time, and link to register.)</li>
          <li>$50 for a sponsored event listing (your logo will be displayed on the event.)</li>
          <li>$100 for a featured event listing (your logo will be displayed on the event and the event will be featured on the calendar on the daily level and communications related to week of the event.)</li>
          <li>$250 for a featured event of the month listing (your logo will be displayed on the event, the event will be featured on the calendar at the monthly level, and all communications during the month of the event.)</li>
          <li>Site sponsorships are also available. Please contact us at <a target="_blank" rel="noopener noreferrer" className="text-blue-500" href="https://www.linkedin.com/company/atl-tech-events">ATL Tech Events on LinkedIn</a> to discuss.</li>
        </ul>
        <p>You must be an authorized representative of the organization hosting the private event to request a listing.</p>

      </div>

        </div>
      </div>
    </div>

  );
}

export default PrivateEvents; 